var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.938,
    height: 54.495,
    viewBox: "0 0 73.938 54.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Containrar",
    transform: "translate(0.957 0.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24330",
    "data-name": "Path 24330",
    d: "M1.319,32.561,6.293,24.77a7.018,7.018,0,0,1,3.282-2.728L48.435,6.319a4.7,4.7,0,0,1,3.635.045l20.606,8.947L28.951,33.2a4.119,4.119,0,0,0-1.9,1.583L17.919,48.934,2.333,37.8A3.874,3.874,0,0,1,1.319,32.561Z",
    transform: "translate(-0.709 -5.976)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1054",
    "data-name": "Line 1054",
    x1: 19.104,
    y1: 10.523,
    transform: "translate(0.563 27.72)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1055",
    "data-name": "Line 1055",
    y2: 9.339,
    transform: "translate(55.746 16.808)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1056",
    "data-name": "Line 1056",
    y2: 9.339,
    transform: "translate(37.461 24.574)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1057",
    "data-name": "Line 1057",
    x1: 0.378,
    y1: 17.879,
    transform: "translate(49.561 0.001)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24331",
    "data-name": "Path 24331",
    d: "M67.92,23.673,63.972,40.55a4.627,4.627,0,0,1-2.766,3.235L31.974,55.667a4.632,4.632,0,0,1-4.164-.342l-14.52-8.9,54.63-22.75L68.047,12.8",
    transform: "translate(3.919 -3.465)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainer);
export default __webpack_public_path__ + "static/media/Icon_container.d4fde873ddce839a9b028a634c3cc1bc.svg";
export { ForwardRef as ReactComponent };